import { mapActions } from "vuex";

export const activitiesTasksDataMixin = {
  data() {
    return {
      loading: false
    };
  },

  computed: {
    /**
     * @returns - gets the present date
     */
    dateNow() {
      return new Date().toISOString().slice(0, 16);
    },
    /**
     *
     * @returns - activity Date
     */
    activityDate() {
      return this.$store.state.activities.activityDate;
    },
    /**
     *
     * @returns list of all users
     */
    allUsers() {
      return this.$store.state.users.allUsers;
    },
    companies() {
      return this.$store.state.companies.companyList;
    },
    stateOptions() {
      return [
        {
          value: "closed",
          text: this.$i18n.tc("ClosedNoun", 1)
        },
        {
          value: "issues",
          text: this.$i18n.tc("Issue", 2)
        },
        {
          value: "in_progress",
          text: this.$i18n.t("InProgress")
        },
        {
          value: "scheduled",
          text: this.$i18n.t("ScheduledAdjective")
        },
        {
          value: "created",
          text: this.$i18n.t("CreatedAdjective")
        },
        {
          value: "assigned",
          text: this.$i18n.t("Assigned")
        },
        {
          value: "completed",
          text: this.$i18n.t("Completed")
        },
        {
          value: "pending_approval",
          text: this.$i18n.t("PendingApproval")
        }
      ];
    },

    approvalType() {
      return [
        {
          id: true,
          label: this.$i18n.t("AutoApproved")
        },
        {
          id: false,
          label: this.$i18n.t("ManualApproval")
        }
      ];
    },

    taskTypeOptions() {
      return [
        // { id: "checklist", label: this.$i18n.t("Checklist") },
        // { id: "text", label: this.$i18n.t("Text") },
        // { id: "photo", label: this.$i18n.tc("Photo",1) },
        { id: "mixed", label: this.$i18n.tc("Mixed") }
        // { id: "serial_number", label: this.$i18n.t("SerialNumber") },
        // { id: "schematic", label: this.$i18n.t("Schematic") },
        // { id: "ifttt", label: "IFTTT" }
      ];
    },

    /**
     *
     * @returns list of object types, objects that are not used are filtered out
     */

    objectTypeOptions() {
      let properties = this.$store.getters.getAllObjectTypesProperties;
      if (properties && properties.length > 0) {
        let options = properties.filter(item => {
          return (
            item.layer !== "fc_building_base" &&
            item.layer !== "fc_customer_premises" &&
            item.layer !== "fc_customer_premises_base" &&
            item.layer !== "fc_pathway_base" &&
            item.layer !== "fc_pole_base" &&
            item.layer !== "fc_manhole_base" &&
            item.layer !== "fc_asset_reservation" &&
            item.layer !== "fc_field_cable" &&
            item.layer !== "fc_cabinet_base" &&
            item.layer !== "fc_influence_line" &&
            item.layer !== "fc_fiber_terminal_box" &&
            item.layer !== "fc_node" &&
            item.layer !== "fc_cartography_point" &&
            item.layer !== "fc_cartography_line" &&
            item.layer !== "fc_cartography" &&
            item.layer !== "fc_technical_point" &&
            item.layer !== "fc_workspace" &&
            item.layer !== "fc_site" &&
            item.layer !== "fc_olt_zone" &&
            item.layer !== "fc_fdp_zone_base" &&
            item.layer !== "fc_fdp_zone" &&
            item.layer !== "fc_closure_zone" &&
            item.layer !== "fc_technical_local_mdu" &&
            item.layer !== "fc_microduct_bundle"
          );
        });
        if (options.length > 0) {
          return options;
        }
        return [];
      }
    },

    getTasksContents() {
      return this.tasksContents;
    }
  },

  methods: {
    ...mapActions(["fetchAllUsers", "fetchAllCompanies"]),

    showDependencies(activity) {
      let shownDependencies = "";
      if (
        activity.hasOwnProperty("dependencies") &&
        activity.dependencies.length > 0
      ) {
        let dependencies = activity.dependencies;
        dependencies.forEach((dependency, index) => {
          shownDependencies += dependency;
          if (index < dependencies.length - 1) {
            shownDependencies += ", ";
          }
        });
      }
      if (shownDependencies === "") {
        shownDependencies = "—";
      }
      return shownDependencies;
    },
    checkLimit(string, limit){
        return string.length > limit;
    },
    isDelayed(activity) {
      if (!activity.due_date || activity.state === "completed") {
        return false;
      } else {
        let dueDate = Date.parse(activity.due_date);
        return activity.state !== "closed" && new Date() > dueDate;
      }
    },

    async loadAllUsers() {
      let fields = { };
      try {
        this.loading = true;
        await this.fetchAllUsers(fields);
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async fetchUserCompanies() {
      try {
        this.loading = true;
        await this.fetchAllCompanies();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    getUserName(userID) {
      let userName;
      if (this.allUsers.length > 0) {
        let user = this.allUsers.find(user => user.id === userID);
        if (user) {
          userName = user.first_name;
          if (user.last_name) {
            userName += " " + user.last_name;
          }
        }
      }
      return userName;
    },
    getCompanyName(companyID) {
      let companyName;
      if (this.companies.length > 0) {
        let company = this.companies.find(company => company.id === companyID);
        if (company) {
          companyName = company.name;
        }
      }
      return companyName;
    },

    getCreatorType(userID) {
      let userType = "";
      if (this.allUsers.length > 0) {
        let user = this.allUsers.find(user => user.id === userID);
        if (user) {
          userType = user.type === "web" ? "mdi-account-tie" : "phone_android";
        }
      }
      return userType;
    },
    getImageUrl(userID) {
      let userImage;
      if (this.allUsers.length > 0) {
        let user = this.allUsers.find(user => user.id === userID);
        if (user) {
          userImage = user.image;
        }
      }
      return userImage;
    },
    getCompanyImage(companyID) {
      let companyImage;
      if (this.companies.length > 0) {
        let company = this.companies.find(company => company.id === companyID);
        if (company) {
          companyImage = company.image;
        }
      }
      return companyImage;
    },

    getFormattedDate(isoDateTime) {
      let dateTime = null;
      if (isoDateTime) {
        let datetime = new Date(isoDateTime);
        dateTime = datetime.toLocaleString("pt-PT", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit"
        });
      }
      return dateTime;
    },

    getStateLabel(stateID) {
      let stateLabel = stateID;
      let state = this.stateOptions.find(item => item.value === stateID);
      if (state) {
        stateLabel = state.text;
      }
      return stateLabel;
    },

    getObjectTypeLabel(objectTypeLayer) {
      return this.$i18n.tc(
        this.$store.getters.getLayerTranslationKey(objectTypeLayer),
        1
      );
    },

    getObjectTypeLabelsList(objectTypes) {
      let objectTypeLabelsList = "";
      let nrObjectTypes = objectTypes.length;
      objectTypes.forEach((objectType, index) => {
        objectTypeLabelsList += this.getObjectTypeLabel(objectType);
        if (index < nrObjectTypes - 1) {
          objectTypeLabelsList += ", ";
        }
      });
      return objectTypeLabelsList;
    },

    getTaskTypeLabel(taskTypeID) {
      let label = taskTypeID;
      if (this.taskTypeOptions.length > 0) {
        let taskType = this.taskTypeOptions.find(
          item => item.id === taskTypeID
        );
        if (taskType) {
          label = taskType.label;
        }
      }
      return label;
    },

    getPossibleLayers(template) {
      if (template) {
        let layers = Object.keys(template.object_type);
        let layerNames = [];

        for (const layer of layers) {
          layerNames.push(this.$store.getters.getLayerTranslationKey(layer));
        }
        let uniq = [...new Set(layerNames)];

        return uniq.join(", ");
      } else {
        return null;
      }
    },
    /**
     *
     * @param {*} date receives scheduled_date
     * @returns scheduled_date plus one hour, added because of v-calendar not giving the correct time after adding a task.
     */
    getDateTime(date) {
      let time = new Date(date);

      time.setHours(time.getHours() + 1);

      return time
        .toISOString()
        .replace("T", " ")
        .substr(0, 19);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/field/activitiesTasksDataMixin.js